import { render, staticRenderFns } from "./InheritPointModal.vue?vue&type=template&id=d8233d0e&scoped=true"
import script from "./InheritPointModal.vue?vue&type=script&lang=js"
export * from "./InheritPointModal.vue?vue&type=script&lang=js"
import style0 from "./InheritPointModal.vue?vue&type=style&index=0&id=d8233d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8233d0e",
  null
  
)

export default component.exports